<template>
  <div>
    <section class="tw-flex">
      <div class="loginLeft">
        <img class="img_bg" src="../../../static/images/login-bg.png" alt="">
        <img class="logo_img" src="../../../static/images/loginLoginWorks.png" alt="">
        <div class="intro">
            <div class="title1">随时随地的编辑器AI助手</div>
            <div class="title2">天工SkyCode可以直接集成到您的编辑器中，无缝衔接在您的开发环境，在您键入代码的同时，迅速补全您的代码。目前我们已经集成在了主流编辑器VS Code中，后续会集成到更多平台和工具，目前还在测试阶段...</div>
            <!-- <div class="multLanguageView tw-flex tw-justify-between tw-items-center">
              <div v-for="(i, index) in 4" :key="index" class="multLanguageViewLi tw-flex tw-items-center tw-flex-col">
                <img :src="require('../../../static/images/logo-editor-type' + i + '.png')" />
                <div class="name font8px">{{i==1?'VS Code':i==2?'Visual Studio':i==3?'Neovim':i==4?'JetBrains IDEs':''}}</div>
              </div>
            </div> -->
        </div>
      </div>
      <div class="loginRight loginDiv">
        <header class="loginTitle">
          <img src="../../../static/images/loginCodeLogo.png" />
          <div class="word">Code faster and better!</div>
        </header>
        <el-form class="self-form">
          <label class="label">手机号码</label>
          <el-input v-model.trim="signUpUserMsg.tel" type="tel" placeholder="请输入手机号" @input="changeInput()" class="same-col" maxlength="11"></el-input>
          <div class="loginTip font10px">{{loginTipShow==1?loginTipWord:''}}</div>
          <label class="label">验证码</label>
          <el-input class="same-col" v-model.trim="signUpUserMsg.telCode" @input="changeInput()" placeholder="请输入6位验证码" maxlength="6">
            <el-button type="text"  class="suffix_button" :class="codeBtn&&'grayWords'" slot="suffix" :disabled="codeBtn" size="small" @click="sendCode">{{codeWords}}</el-button> 
          </el-input>
          <div class="loginTip font10px">{{loginTipShow==2?loginTipWord:''}}</div>
          <div class="userCheckboxDiv tw-flex" @click="checkedImgBtn"><img :src="userAgreeChecked?require('../../../static/images/is-checked.png'):require('../../../static/images/empty-checked.png')" /><div class="works">同意并接受<a :href="$axiosUrl.UserAgreementSrc" target="_blank">《用户协议》</a>和<a :href="$axiosUrl.PrivacyTermsSrc" target="_blank">《隐私条款》</a></div></div>
          <div class="loginTip font10px">{{loginTipShow==3?loginTipWord:''}}</div>
          <el-button type="primary" :loading="sureLoginBtnLoading" @click="sureLogin" size="large" class="login-button linearBtnBg">登录</el-button>
          
        </el-form>
      </div>
    </section>
  </div>
</template>

<script>
import { successMsg } from '../../utils/confirm'
export default {
  data () {
    return {
      signUpUserMsg: {
        tel: '',
        telCode: ''
      },
      codeBtn: false, // 发送按钮时候是禁用
      countdown: 60, // 倒计时
      codeWords: '获取验证码', // 发送验证码文字
      sureLoginBtnLoading: false, // 登录按钮样式
      loginTipShow: 0, // 0不显示 1手机号 2验证码 3同意协议
      userAgreeChecked: false, // 是否选择同意协议
      loginTipWord: '',
      code: '', // 页面链接携带
      getHeartCodeTimer: '', // code心跳计时器
    }
  },
  created () {
    this.$actionBuryPointWay('','login-page','open','')
    this.code = this.$route.query.code || ''
    console.log(this.code);
    // 如果有code 就执行一个心跳函数：每隔10s请求一次，如果关闭了就不管了
    if(this.code) {this.getLoginHeart()}
  },
  methods: {
    getLoginHeart(){
      let that = this
      that.$get(that.$axiosUrl.loginHeart, {code: that.code})
        .then((response) => {
          console.log(response)
          that.getHeartSetIntervalrWay()
        })
    },
    getHeartSetIntervalrWay () {
        let _this = this
        if (_this.getHeartCodeTimer == '') {
            console.log("-----");
            var getHeartCodeTimer = setInterval(function(){_this.getLoginHeart();console.log('getHeartCodeTimer计时器还在工作'); }, 10000); // 10s
            _this.getHeartCodeTimer = getHeartCodeTimer;
        }
    },
    sureLogin () {
      var that = this
      if(!that.signUpUserMsg.tel) {that.loginTipShow = 1; that.loginTipWord = '请输入正确的手机号'; return}
      if(!that.signUpUserMsg.telCode) {that.loginTipShow = 2; that.loginTipWord = '请输入验证码'; return}
      if(!that.userAgreeChecked) {that.loginTipShow = 3; that.loginTipWord = '请勾选同意协议'; return}
      that.loginTipShow = 0
      that.getLoginData()
    },
    async getLoginData (){
      // 跳转页面
      let that = this
      var loginData = {phone: that.signUpUserMsg.tel, verifyCode: that.signUpUserMsg.telCode, uuid: that.code}
      console.log(loginData)
      that.sureLoginBtnLoading = true
      that.$jsonPost(that.$axiosUrl.getLogin, loginData)
        .then((response) => {
          console.log(response)
          successMsg('登录成功！')
          that.sureLoginBtnLoading = false
          that.$store.dispatch('GetBaseInfo', response.resp_data)
          clearInterval(that.getHeartCodeTimer); 
          that.$router.push('/')
        }).catch(()=>{that.sureLoginBtnLoading = false})
    },
    // 发送验证码
    sendCode () {
          var that = this
          console.log(that.signUpUserMsg.tel)
          var reg = /^1[23456789]\d{9}$/
          if (reg.test(that.signUpUserMsg.tel)) {
            // 手机号正确 请求接口
            that.loginTipShow = false
            that.getCode()
          } else {
            console.log('请输入正确的手机号')
            that.loginTipShow = true
            that.loginTipWord = '请输入正确的手机号'
          }
        },
        setTime () {
          var that = this
          var timeStop = setTimeout(function () {
            that.setTime()
          }, 1000)
          that.countdown--
          if (that.countdown === 0) {
            that.codeBtn = false // 按钮可以点击了
            that.codeWords = '重新发送'
            that.countdown = 60
            clearInterval(timeStop) // 清除定时器
          } else {
            that.codeBtn = true // 按钮禁止点击
            that.codeWords =  '重新发送'+that.countdown+'S'
          }
        },
        //   获取验证码
        getCode () {
          var that = this
          that.$jsonPost(that.$axiosUrl.verifyCode, {phone: that.signUpUserMsg.tel})
            .then((response) => {
              console.log(response)
              successMsg('发送成功')
              that.codeBtn = true // 按钮禁止点击
              that.setTime()
            })
        },
        changeInput () {
          this.sureLoginBtnLoading = false
        },
        checkedImgBtn() {
          this.userAgreeChecked = !this.userAgreeChecked
        }
  },
  destroyed() {
      clearInterval(this.getHeartCodeTimer);
  }
}

</script>

<style scoped lang="less">
.loginLeft {
  position: relative;
  width: 55.729vw;
  height: 100vh;
  overflow-y: hidden;
  background: linear-gradient(89.87deg, #03040D 0.02%, #02020F 50.27%, #020210 99.81%);
 .img_bg {
    position: absolute;
    width: 100%;
  }
  .logo_img {
    position: absolute;
    z-index: 9;
    top: 40px;
    left: 55px;
    width: 5.8854vw;
    height: 1.979vw;
    max-width: 113px;
    max-height: 38px;
  }
  .intro {
    position: absolute;
    z-index: 9;
    top: 37.34vw; // 距上
    // bottom: 5.208vw;
    font-family: 'Inter';
    .title1 {
      text-align: center;
      font-weight: 700;
      font-size: 24px;
      line-height: 29px;
      letter-spacing: 1px;
      color: #EFF5FA;
    }
    .title2 {
      padding: 0 15.888%;
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      letter-spacing: 1px;
      color: rgba(239, 245, 250, 0.8);
      // margin: 20px auto 80px;
      margin: 1.0416vw auto 0;
    }
    .multLanguageView {
      margin: 0 27.10%;
    }
    .multLanguageViewLi {
      width: 85px;
      height: 60px;
      img {
        width: 40px;
        height: 40px;
        margin-bottom: 4px;
      }
      .name {
        font-weight: 600;
        // font-size: 8px;
        line-height: 10px;
        color: #FFFFFF;
        text-align: center;
      }
    }
  }
}
.loginRight {
  width: 44.27vw;
  min-width: 400px;
  height: 100vh;
}
  .loginRight {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  
  .loginTitle {
    width: 356px;
    margin-bottom: 44px;
    img {
      width: 134px;
      height: 29px;
      margin-bottom: 16px;
    }
    .word {
      font-family: 'Inter';
      font-weight: 700;
      font-size: 26px;
      line-height: 31px;
      letter-spacing: 0.6px;
      color: #242F57;
    }
  }
  .suffix_button {
    height: 51px;
    margin-right: 16px;
    color: #514CFF;
    font-size: 14px;
    font-weight: normal;
  }
  .grayWords {
    font-size: 12px;
    color: rgba(40, 47, 54, 0.3);
  }
  .userCheckboxDiv {
    cursor: pointer;
    align-items: center;
    // margin-top: 20px;
    img {
      width: 28px;
      height: 28px;
      margin-right: 10px;
    }
    .works {
      color: #464343;
      white-space:nowrap;
      font-size: 12px;
      a {
        color: rgba(81, 76, 255, 0.9);
      }
    }
    
  }
  .loginTip {
    font-size: 12px;
    height: 24px;
    line-height: 24px;
    color: #FB4539;
  }

//  新的
.self-form {
    width: 356px;
    .label {
      display: block;
      font-weight: 700;
      font-size: 13px;
      line-height: 16px;
      letter-spacing: 1.6px;
      color: #97A0C3;
      margin-bottom: 16px;
    }
}
.login-button {
    display: block;
    margin-top: 16px;
    width: 356px;
    height: 51px;
    border: none;
    font-size: 18px !important;
    font-weight: 700 !important;
    border-radius: 10px !important;
  }

</style>
<style lang="less">
  .loginRight .el-input {
    font-size: 16px;
  }
  .loginRight .el-input__inner {
    background-color: #fff;
    border: 1px solid #7780A1;
    font-size: 16px;
    color: #606266;
    height: 51px;
    line-height: 51px;
    padding: 0;
    width: 356px;
    padding-left: 16px;
    border-radius: 10px;
  }
  .el-input__suffix {
    height: 39px !important;
    color: #C0C4CC !important;
    top: 0 !important;
}
.el-checkbox__input.is-checked+.el-checkbox__label {
  color: #606266;
}

</style>
